<template>
  <div
    class="buttons"
    :class="{
      open: Open,
    }"
  >
    <div
      v-for="(Button, ButtonIndex) in Buttons"
      class="buttons__item"
      @click="SetContent(Button)"
      :class="{
        active:
          Content == Button.cod || (Button.cod == 'comparador' && Comparador),
      }"
    >
      <div class="buttons__item__miniatura">
        <img
          :src="require('@/assets/Images/' + Button.miniatura)"
          alt=""
          class="buttons__item__miniatura__image"
        />
      </div>
      <p class="buttons__item__text">
        {{
          Button.literales[
            Button.literales.findIndex(
              (Literal) => Literal.codIdioma == Language
            )
          ].texto
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Buttons",
  props: {
    Language: String,
    Open: Boolean,
    Buttons: Array,
    Content: String,
    Comparador: Boolean,
  },
  methods: {
    SetContent(Object) {
      if (Object.cod == "comparador") {
        this.$emit("Comparador", !this.Comparador);
      } else if (Object.cod == "cerrar") {
        this.$emit("Content", "");
        this.$emit("Open", false);
      } else {
        if (this.Content != Object.cod) {
          this.$emit("Content", Object.cod);
          this.$emit("Open", true);
        } else {
          this.$emit("Content", "");
          this.$emit("Open", false);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  position: absolute;
  bottom: 10dvh;
  right: 0;
  -webkit-transition: right 0.35s ease-in-out;
  -moz-transition: right 0.35s ease-in-out;
  -ms-transition: right 0.35s ease-in-out;
  -o-transition: right 0.35s ease-in-out;
  transition: right 0.35s ease-in-out;
  &__item {
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-content: center;
    &__miniatura {
      width: 40px;
      height: 40px;
      padding: 8px;
      background-color: white;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
      &__image {
        filter: invert(0%);
        width: 100%;
        height: 100%;
        object-fit: cover;
        -webkit-transition: filter 0.35s ease-in-out;
        -moz-transition: filter 0.35s ease-in-out;
        -ms-transition: filter 0.35s ease-in-out;
        -o-transition: filter 0.35s ease-in-out;
        transition: filter 0.35s ease-in-out;
      }
    }
    &__text {
      filter: invert(0%);
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: 50px;
      background-color: black;
      color: white;
      font-size: 10px;
      padding: 4px 14px;
      -webkit-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
    }
    &:hover {
      & .buttons__item {
        &__text {
          opacity: 1;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }
    &:first-child {
      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 0px;
        }
      }
    }
    &:nth-child(3) {
      & .buttons__item {
        &__miniatura {
          border-radius: 0px 0px 0px 5px;
        }
      }
    }
    &:last-child {
      opacity: 0;
      pointer-events: none;
      margin-top: 40px;
      -webkit-transition: opacity 0.35s ease-in-out;
      -moz-transition: opacity 0.35s ease-in-out;
      -ms-transition: opacity 0.35s ease-in-out;
      -o-transition: opacity 0.35s ease-in-out;
      transition: opacity 0.35s ease-in-out;
      & .buttons__item {
        &__miniatura {
          border-radius: 5px 0px 0px 5px;
        }
      }
    }
    &.active {
      & .buttons__item {
        &__miniatura {
          background-color: black;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;
          &__image {
            filter: invert(100%);
            -webkit-transition: filter 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out;
          }
        }
      }
    }
  }
  &.open {
    right: 350px;
    -webkit-transition: right 0.35s ease-in-out;
    -moz-transition: right 0.35s ease-in-out;
    -ms-transition: right 0.35s ease-in-out;
    -o-transition: right 0.35s ease-in-out;
    transition: right 0.35s ease-in-out;
    & .buttons {
      &__item {
        &:last-child {
          opacity: 1;
          pointer-events: visible;
          -webkit-transition: opacity 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out;
        }
      }
    }
  }
}
</style>
